"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxUpdateCalendarItemArgs = void 0;
var HxCalendarTimeData_1 = require("./HxCalendarTimeData");
var HxLocationEntityDataArgs_1 = require("./HxLocationEntityDataArgs");
var HxCalendarReminderData_1 = require("./HxCalendarReminderData");
var HxBodyData_1 = require("./HxBodyData");
var HxRepeatSeriesInfoArgs_1 = require("./HxRepeatSeriesInfoArgs");
var HxAttendeeData_1 = require("./HxAttendeeData");
var HxRecipientData_1 = require("./HxRecipientData");
var HxUtcFloatableTimeRange_1 = require("./HxUtcFloatableTimeRange");
function serializeHxUpdateCalendarItemArgs(_arg) {
    var output = [];
    output.push(_arg.repeatItemType);
    output.push(_arg.calendarTime !== undefined);
    if (_arg.calendarTime !== undefined) {
        output.push(HxCalendarTimeData_1.serializeHxCalendarTimeData(_arg.calendarTime));
    }
    output.push(_arg.subject !== undefined);
    if (_arg.subject !== undefined) {
        output.push(_arg.subject);
    }
    output.push(_arg.location !== undefined);
    if (_arg.location !== undefined) {
        output.push(_arg.location);
    }
    output.push(_arg.enhancedLocations !== undefined);
    if (_arg.enhancedLocations !== undefined) {
        var enhancedLocationsOutput_1 = [];
        _arg.enhancedLocations.forEach(function (item) { return enhancedLocationsOutput_1.push(HxLocationEntityDataArgs_1.serializeHxLocationEntityDataArgs(item)); });
        output.push(enhancedLocationsOutput_1);
    }
    output.push(_arg.categories !== undefined);
    if (_arg.categories !== undefined) {
        var categoriesOutput_1 = [];
        _arg.categories.forEach(function (item) { return categoriesOutput_1.push(item); });
        output.push(categoriesOutput_1);
    }
    output.push(_arg.calendarReminder !== undefined);
    if (_arg.calendarReminder !== undefined) {
        output.push(HxCalendarReminderData_1.serializeHxCalendarReminderData(_arg.calendarReminder));
    }
    output.push(_arg.freeBusyState !== undefined);
    if (_arg.freeBusyState !== undefined) {
        output.push(_arg.freeBusyState);
    }
    output.push(_arg.intendedFreeBusyState !== undefined);
    if (_arg.intendedFreeBusyState !== undefined) {
        output.push(_arg.intendedFreeBusyState);
    }
    output.push(_arg.sensitivity !== undefined);
    if (_arg.sensitivity !== undefined) {
        output.push(_arg.sensitivity);
    }
    output.push(_arg.importance !== undefined);
    if (_arg.importance !== undefined) {
        output.push(_arg.importance);
    }
    output.push(_arg.responsesRequested !== undefined);
    if (_arg.responsesRequested !== undefined) {
        output.push(_arg.responsesRequested);
    }
    output.push(_arg.bodyData !== undefined);
    if (_arg.bodyData !== undefined) {
        output.push(HxBodyData_1.serializeHxBodyData(_arg.bodyData));
    }
    output.push(_arg.repeatSeriesData !== undefined);
    if (_arg.repeatSeriesData !== undefined) {
        output.push(HxRepeatSeriesInfoArgs_1.serializeHxRepeatSeriesInfoArgs(_arg.repeatSeriesData));
    }
    output.push(_arg.attendees !== undefined);
    if (_arg.attendees !== undefined) {
        var attendeesOutput_1 = [];
        _arg.attendees.forEach(function (item) { return attendeesOutput_1.push(HxAttendeeData_1.serializeHxAttendeeData(item)); });
        output.push(attendeesOutput_1);
    }
    output.push(_arg.forwardees !== undefined);
    if (_arg.forwardees !== undefined) {
        var forwardeesOutput_1 = [];
        _arg.forwardees.forEach(function (item) { return forwardeesOutput_1.push(HxRecipientData_1.serializeHxRecipientData(item)); });
        output.push(forwardeesOutput_1);
    }
    output.push(_arg.removedAttendees !== undefined);
    if (_arg.removedAttendees !== undefined) {
        var removedAttendeesOutput_1 = [];
        _arg.removedAttendees.forEach(function (item) { return removedAttendeesOutput_1.push(item); });
        output.push(removedAttendeesOutput_1);
    }
    output.push(_arg.addedInstances !== undefined);
    if (_arg.addedInstances !== undefined) {
        var addedInstancesOutput_1 = [];
        _arg.addedInstances.forEach(function (item) { return addedInstancesOutput_1.push(HxUtcFloatableTimeRange_1.serializeHxUtcFloatableTimeRange(item)); });
        output.push(addedInstancesOutput_1);
    }
    output.push(_arg.removedInstancesClientIds !== undefined);
    if (_arg.removedInstancesClientIds !== undefined) {
        var removedInstancesClientIdsOutput_1 = [];
        _arg.removedInstancesClientIds.forEach(function (item) { return removedInstancesClientIdsOutput_1.push(item.toString()); });
        output.push(removedInstancesClientIdsOutput_1);
    }
    output.push(_arg.isOnlineMeeting !== undefined);
    if (_arg.isOnlineMeeting !== undefined) {
        output.push(_arg.isOnlineMeeting);
    }
    output.push(_arg.onlineMeetingConfLink !== undefined);
    if (_arg.onlineMeetingConfLink !== undefined) {
        output.push(_arg.onlineMeetingConfLink);
    }
    output.push(_arg.onlineMeetingExternalLink !== undefined);
    if (_arg.onlineMeetingExternalLink !== undefined) {
        output.push(_arg.onlineMeetingExternalLink);
    }
    output.push(_arg.onlineMeetingProvider !== undefined);
    if (_arg.onlineMeetingProvider !== undefined) {
        output.push(_arg.onlineMeetingProvider);
    }
    output.push(_arg.charm !== undefined);
    if (_arg.charm !== undefined) {
        output.push(_arg.charm);
    }
    output.push(_arg.doNotForwardMeeting !== undefined);
    if (_arg.doNotForwardMeeting !== undefined) {
        output.push(_arg.doNotForwardMeeting);
    }
    output.push(_arg.disallowNewTimeProposal !== undefined);
    if (_arg.disallowNewTimeProposal !== undefined) {
        output.push(_arg.disallowNewTimeProposal);
    }
    output.push(_arg.isDraft !== undefined);
    if (_arg.isDraft !== undefined) {
        output.push(_arg.isDraft);
    }
    return output;
}
exports.serializeHxUpdateCalendarItemArgs = serializeHxUpdateCalendarItemArgs;
